import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { makeStyles } from '@material-ui/core/styles'
import { ForgotPasswordComponent } from '../../../../../Components/ForgotPassword'

const useStyles = makeStyles((theme) => ({
  root: {

  }
}))

export const DialogForgotPassword = ({
  open = false,
  onClose
}) => {
  const classes = useStyles()
  return (
    <Dialog
      className={classes.root}
      open={open}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      onClose={onClose}
      aria-labelledby="responsive-dialog-title">
      <DialogTitle>Esqueci minha senha</DialogTitle>
      <DialogContent>
        <ForgotPasswordComponent
          onSuccess={onClose}
        />
      </DialogContent>
      <DialogActions>
        <Button size="small" onClick={onClose} color="secondary">
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  )
}
